import loadResource from '../../resource/loadResource';
import FlowerObject from '../object/FlowerObject';
import renderReal from "../../render/renderReal";
class ReplaceCommand {
    constructor(params, env) {
        this.params = params;
        this.env = env;
        this.originalResourceId = null;
        this.containChange=true;
    }
    async do() {
        for (let index = 0; index < this.env.objects.flowers.length; index++) {
            const flowerObject = this.env.objects.flowers[index];
            if (this.params.id === flowerObject.id) {
                if (!this.originalResourceId) {
                    this.originalResourceId = flowerObject.resource.id;
                }
                if (!this.env.resource[this.params.resourceId]) {
                    this.env.resource[this.params.resourceId] = await loadResource(this.params.resourceId);
                }
                const resource = this.env.resource[this.params.resourceId];
                const nextRenderType = resource.resourceRenderType || (resource.detail && resource.detail.format === 'glb' ? 'glb' : 'sprite');
                const currentRenderType = flowerObject.renderType || (flowerObject.isGlbResource ? 'glb' : 'sprite');
                if (nextRenderType === 'glb' || currentRenderType === 'glb') {
                    const position = flowerObject.modelMesh.flowerMesh.position.clone();
                    const params = JSON.parse(JSON.stringify(flowerObject.params));
                    flowerObject.remove();
                    const nextFlowerObject = new FlowerObject({
                        resource,
                        id: this.params.id,
                        env: this.env,
                        position,
                        params
                    });
                    this.env.objects.flowers.splice(index, 0, nextFlowerObject);
                    if (nextFlowerObject.initPromise) {
                        try {
                            await nextFlowerObject.initPromise;
                        } catch (error) {
                            nextFlowerObject.remove();
                            if (this.env.listener['error']) {
                                this.env.listener['error']({
                                    msg: `花材加载失败：${error && error.message ? error.message : '未知错误'}`
                                });
                            }
                            throw error;
                        }
                    }
                    this.env.syncLayerState();
                    break;
                }
                flowerObject.changeResource(resource);
                flowerObject.clearReal();
                break;
            }
        }
        renderReal(this.env);
    }
    async prev() {
        for (let index = 0; index < this.env.objects.flowers.length; index++) {
            const flowerObject = this.env.objects.flowers[index];
            if (this.params.id === flowerObject.id) {
                const resource = this.env.resource[this.originalResourceId];
                const nextRenderType = resource.resourceRenderType || (resource.detail && resource.detail.format === 'glb' ? 'glb' : 'sprite');
                const currentRenderType = flowerObject.renderType || (flowerObject.isGlbResource ? 'glb' : 'sprite');
                if (nextRenderType === 'glb' || currentRenderType === 'glb') {
                    const position = flowerObject.modelMesh.flowerMesh.position.clone();
                    const params = JSON.parse(JSON.stringify(flowerObject.params));
                    flowerObject.remove();
                    const prevFlowerObject = new FlowerObject({
                        resource,
                        id: this.params.id,
                        env: this.env,
                        position,
                        params
                    });
                    this.env.objects.flowers.splice(index, 0, prevFlowerObject);
                    if (prevFlowerObject.initPromise) {
                        await prevFlowerObject.initPromise;
                    }
                    this.env.syncLayerState();
                    break;
                }
                flowerObject.changeResource(resource);
                flowerObject.clearReal();
                break;
            }
        }
        renderReal(this.env);
    }
}

export default ReplaceCommand;
